import React, { useEffect, useState, forwardRef, useImperativeHandle, memo, useMemo, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import { Grid, Checkbox, FormGroup, FormControlLabel, Chip, Paper, FormControl, FormLabel, TextField, Button, Select, MenuItem, InputLabel, Menu } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, AppBar, Toolbar, Backdrop, CircularProgress, Switch, Drawer, CssBaseline, Stack,Tabs,Tab, Tooltip, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import _, { omit, pick } from 'lodash'
import PF from "../_Services/publicFunction";
import { useSnackbar } from "notistack";
import Qs from "qs";
import NumberFormat from 'react-number-format';
import dayjs from 'dayjs';
import { DatePicker, Space, Radio } from 'antd';
import locale from 'antd/es/date-picker/locale/zh_TW';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import PageviewIcon from '@mui/icons-material/Pageview';
import SendIcon from '@mui/icons-material/Send';
import { injectIntl, intlShape, useIntl, FormattedMessage } from 'react-intl';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import Minmax from './MinmaxMobile';
import { indigo, grey, red, blue, teal } from '@mui/material/colors';
import GetAppIcon from '@mui/icons-material/GetApp';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import FileDownloadOffIcon from '@mui/icons-material/FileDownloadOff';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../reducers/app";
import useSound from 'use-sound';
import switchlight from '../components/sounds/switchlight.wav';
import { useTheme } from '@mui/material/styles';
import { saveAs } from "file-saver";

import { DarkModeSwitch } from 'react-toggle-dark-mode';
import moment from "moment";
import CryptoJS from "crypto-js";
import { GTranslate } from '@mui/icons-material';
import GenerateReport from './GenerateReport';
import AnnualReport from './AnnualReport';
import QueryLostitem from './QueryLostitem';



//後台使用
//非顧客使用
var week = ['日', '一', '二', '三', '四', '五', '六']

// const useStyles = makeStyles((theme) => ({
//     root: {
//         width: '100%',
//     },

//     half_background: {
//         background: "linear-gradient(to top, yellow 50%, transparent 50%)"
//     },
//     backdrop: {
//         zIndex: theme.zIndex.drawer + 1,
//         color: '#fff',
//     },
//     closeButton: {
//         position: 'absolute',
//         right: theme.spacing(1),
//         top: theme.spacing(1),
//         color: theme.palette.grey[500],
//     },
//     chip: {
//         margin: theme.spacing(0.5),
//     },
// }));
//後台使用
//非顧客使用

const drawerWidth = 240;
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);
const AppBar2 = styled(AppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        // minHeight: '50px',
        // height: '50px',
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));
const SwitchAllStatusButton = ({ rowData, setRowData }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [allStatus, setAllStatus] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (!rowData || rowData.length === 0) return;
        setAllStatus(rowData.every(r => r.status === "Y"));
    }, [rowData]);

    const handleSetAllStatus = async (status) => {
        if (!rowData || rowData.length === 0) return;

        setIsUpdating(true);
        setProgress(0);

        let successCount = 0;
        let failCount = 0;
        let completed = 0;

        const total = rowData.length;

        const requests = rowData.map(r =>
            PF.instance({
                method: "post",
                url: PF.url2 + "/Minmax/SetAllStatus",
                data: Qs.stringify({
                    Action: "UPDATE",
                    parameter: {
                        PersonalId: r.PersonalId,
                        Status: status
                    }
                }),
                headers: { token: sessionStorage.token }
            })
            .then(res => {
                if (res.data?.TotalRecord > 0) {
                    successCount++;
                    return { success: true, id: r.PersonalId };
                } else {
                    failCount++;
                    return { success: false };
                }
            })
            .catch(() => {
                failCount++;
                return { success: false };
            })
            .finally(() => {
                completed++;
                setProgress(completed); // 即時更新進度
            })
        );

        const results = await Promise.all(requests);

        // 批量更新前端資料（只更新成功的）
        const successIds = results
            .filter(r => r.success)
            .map(r => r.id);

        setRowData(prev =>
            prev.map(item =>
                successIds.includes(item.PersonalId)
                    ? { ...item, status }
                    : item
            )
        );

        setIsUpdating(false);
        setAllStatus(status === "Y");

        enqueueSnackbar(
            `整頁更新完成：成功 ${successCount} 筆，失敗 ${failCount} 筆`,
            { variant: failCount === 0 ? "success" : "warning" }
        );
    };

    return (
        <Button
            variant={allStatus ? "contained" : "outlined"}
            color={allStatus ? "secondary" : "primary"}
            onClick={() => handleSetAllStatus(allStatus ? "N" : "Y")}
            sx={{ ml: 1 }}
            disabled={isUpdating}
        >
            {isUpdating
                ? `更新中 ${progress}/${rowData?.length}`
                : `狀態 ${allStatus ? "關" : "開"}`}
        </Button>
    );
};

// 單筆 Switch
const SwitchStatus = ({ value, data, setValue, refreshCell, rowData, setRowData }) => {
    const { enqueueSnackbar } = useSnackbar();

    const handleSetStatus = (newStatus) => {
        PF.instance({
            method: "post",
            url: PF.url2 + "/Minmax/SetStatus",
            data: Qs.stringify({
                Action: "UPDATE",
                parameter: {
                    qc_id: data.id,
                    Status: newStatus
                }
            }),
            headers: { token: sessionStorage.token }
        }).then((response) => {
            const { TotalRecord } = response.data;
            if (TotalRecord > 0) {
                enqueueSnackbar("更新成功", { variant: "success" });
                // 更新 rowData 單筆狀態
                const newData = rowData.map(r =>
                    r.id === data.id ? { ...r, status: newStatus } : r
                );
                setRowData(newData);
            } else {
                enqueueSnackbar("更新失敗", { variant: "error" });
            }
        });
    };

    const handleChange = () => {
        const newStatus = value === "Y" ? "N" : "Y";
        handleSetStatus(newStatus);
        setValue(newStatus);
        refreshCell();
    };

    return <Switch checked={value === "Y"} size="small" onChange={handleChange} />;
};
const CustomEmailEditor = (props) => {
    const [value, setValue] = useState(props.value);
    const [isValid, setIsValid] = useState(true);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setValue(newValue);
        setIsValid(validateEmail(newValue)); // 使用 validateEmail 函數驗證 email
        props.node.setDataValue(props.colDef.field, newValue);
    };

    const validateEmail = (email) => {
        // 此處使用簡單的正則表達式驗證 email，你可以根據需要擴展驗證邏輯
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return emailRegex.test(email);
    };

    return (
        <div>
            <input
                type="text"
                value={value}
                onChange={handleChange}
                style={{ borderColor: isValid ? 'initial' : 'red', width: '100%' }}
            />
            {!isValid && <div style={{ color: 'red' }}>請輸入有效的Email地址</div>}
        </div>
    );
};

// export default CustomEmailEditor;
const CustomInputEditor = (props) => {
    const [value, setValue] = useState(props.value);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setValue(newValue);
        props.node.setDataValue(props.colDef.field, newValue);
    };

    return <input type="text" value={value} onChange={handleChange} />;
};
const App = (props) => {
    const [rowData, setRowData] = useState([])
    const intl = useIntl();
    const [QueryDate, setQueryDate] = useState(dayjs().format('YYYY/MM/DD'));
    const handleDateChange = (date, dateString) => {
        setQueryDate(dateString)
    }
    const handlePreviosDate = () => {
        let PrevDate = dayjs(QueryDate).add(-1, 'days')

        handleDateChange(PrevDate, PrevDate.format('YYYY/MM/DD'));
    }
    const handleNextDate = () => {
        let PrevDate = dayjs(QueryDate).add(1, 'days')
        handleDateChange(PrevDate, PrevDate.format('YYYY/MM/DD'));
    }


    useEffect(() => {

        // let user = {
        //     PersonalId: "L123532327"
        // }
        // localStorage.setItem("UserInfo", JSON.stringify(user));
        // console.log(localStorage.getItem("UserInfo"))

        dispatch(actions.UserInfo(JSON.parse(localStorage.getItem("UserInfo"))));
    }, [])
    const dispatch = useDispatch();
    const { UserInfo, dark, token, i18n } = useSelector(state => ({
        UserInfo: state.app.UserInfo,
        dark: state.app.dark,
        token: state.app.token,
        i18n: state.app.i18n,
    }));
    const [playActive] = useSound(
        switchlight,
        { volume: 0.5 }
    );
    const [url, seturl] = useState(null);
    const [BackdropOpen, setBackdropOpen] = React.useState(false);
    // const classes = useStyles();
    const [QueryString, setQueryString] = React.useState('');
    const PicCategoryArray = ["超音波檢查", "數位斷層合成掃描", '胸部能量減影',
        , "一般X光"
        , "三連片"
        , "內視鏡"
        , "身體組成分析"
        , "心電圖"
        , "自律神經檢查"
        , "眼底攝影"];

    const CategoryArray05 = [
        { id2: "0501", title2: "超音波檢查" },
        { id2: "0502", title2: "數位斷層合成掃描" },
        { id2: "0503", title2: "胸部能量減影" },
        { id2: "0504", title2: "一般X光" },
        { id2: "0505", title2: "三連片" },
        { id2: "0506", title2: "內視鏡" },
        { id2: "0507", title2: "身體組成分析" },
        { id2: "0508", title2: "心電圖" },
        { id2: "0509", title2: "自律神經檢查" },
        { id2: "0510", title2: "眼底攝影" },
    ];

    const handleChange = event => {
        const { name, value } = event.target;
        setQueryString(value);
    }
    const { enqueueSnackbar } = useSnackbar();
    const gridRef = React.useRef();
    const reportLoadSeqRef = React.useRef(0);

    const [GaugeItem, setGaugeItem] = useState({})
    // const [LabItem, setLabItem] = useState({})

    const [PicObj, setPicObj] = useState({})
    const [Profile, setProfile] = useState({})
    const [Array02_1, setArray02_1] = useState([])
    const [Array02_2, setArray02_2] = useState([])
    const [Array02, setArray02] = useState([])
    const [Array03, setArray03] = useState([])
    const [Array04, setArray04] = useState([])
    const [Array06, setArray06] = useState([])
    const initialItems = [{ id: '01', title: ' - 基本資料', i18n: intl.formatMessage({ id: "基本資料" }) }, { id: '02', title: ' - 異常項目', i18n: intl.formatMessage({ id: "異常項目" }) }
        // { id: '04', title: '04 - 檢驗', data: Array04 },
        // { id: '05', title: '05 - 影像檢查', data: GaugeItem },
        // { id: '06', title: '06 - 其他檢查', data: Array06 },

    ]
    const [items, setitems] = useState(initialItems)
    const initialsubItems = {
        '03': [{ id2: '0301', title2: '一般體格', i18n2: intl.formatMessage({ id: "一般體格" }) }, { id2: '0302', title2: '醫生問診', i18n2: intl.formatMessage({ id: "醫生問診" }) }],
        '04': [],
        '05': [],
        '06': []
    }
    const [subItems, setsubItems] = useState(initialsubItems)
    const resetReportState = () => {
        setitems(initialItems);
        setArray02([]);
        setArray02_1([]);
        setArray02_2([]);
        setsubItems(initialsubItems);
        setProfile({});
        setPicObj({});
        setArray03([]);
        setArray04([]);
        setArray06([]);
        setGaugeItem({});
    }
    const onRowDoubleClicked = (event) => {
        const { data, column } = event;
        // console.log(column)
        // console.log(data.barcode);
        if (column.colId !== 'barcode' && column.colId !== 'email') {
            // 在這裡執行雙擊邏輯
            getFullData(data.barcode)
            // handleQueryBarCodeStr(data.barcode);
            // setBarCodeStr(data.BarCodeStr);
            // handleClose();
            setOpen(true)
        }


    }
    const onCellValueChanged = params => {
        const editedData = params.data;
        var columnName = params.colDef.field;
        const { PersonalId, email } = editedData;
        // console.log(params)
        // console.log(editedData)

        if (PF.isValidEmail(email)) {
            PF.instance({
                method: "post",
                url: PF.url2 + "/Minmax/SetEmail",
                data: Qs.stringify({
                    Action: "1",
                    parameter: {
                        qc_id: PersonalId,
                        Email: email
                    }
                }),
                headers: { token: sessionStorage.token }
            })
                .then(function (response) {

                    // console.log(response.data)
                    const { TotalRecord, rows } = response.data
                    if (rows[0].status <= 0) {
                        // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                        enqueueSnackbar("查無資料", { variant: "error", style: { whiteSpace: 'pre-line' } });
                    } else {
                        // enqueueSnackbar("Success", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        // console.log(rows)

                    }
                    handleQuery();

                })


        } else {
            enqueueSnackbar("無效的email請重新輸入", { variant: "error", style: { whiteSpace: 'pre-line' } });
            // 如果輸入無效，還原為先前的值
            params.data[columnName] = params.oldValue;
            // 更新單元格以顯示還原後的值
            params.api.refreshCells({ columns: [columnName] });
        }



    }
    const SendNotify = (props) => {
        const { value, data, refreshCell, setValue, setDataValue } = props;
        let User = JSON.parse(localStorage.getItem("UserInfo"))

        const handleSetStatus = () => {
            PF.instance({
                method: "post",
                url: PF.url2 + "/Minmax/EmailNotify",
                data: Qs.stringify({
                    Action: "CHECK",
                    parameter: {
                        qc_id: data.id,
                        Email: data.email,
                        CustName: data.UserName,
                        CheckDate: data.checkdate,
                        PersonalId: User?.PersonalId
                    }
                }),
                headers: { token: sessionStorage.token }
            })
                .then(function (response) {

                    const { TotalRecord, Err, rows } = response.data;
                    const [ErrMsg] = Err;
                    // console.log(ErrMsg)
                    if (ErrMsg.ErrMsg === "1") {
                        // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                        enqueueSnackbar("更新成功", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        gridRef.current.api.applyTransaction({ update: rows })
                    } else {
                        enqueueSnackbar("更新失敗", { variant: "error", style: { whiteSpace: 'pre-line' }, autoHideDuration: 3000 });

                    }
                })


        }
        //改為拖曳派車
        const handleNotify = () => {
            if (data.status === "N") {
                enqueueSnackbar("請先啟用狀態", { variant: "warning", style: { whiteSpace: 'pre-line' } });
                return
            }
            if (!PF.isValidEmail(data.email)) {
                enqueueSnackbar("非email格式", { variant: "warning", style: { whiteSpace: 'pre-line' } });
                return
            }
            handleSetStatus();

        }
        return (
            <Button size="small" variant='contained' color={data.SendCount > 0 ? "secondary" : "success"}
                onClick={handleNotify} sx={{ width: 50 }} endIcon={<SendIcon />}
            >{value}</Button>)
    }
    useEffect(() => {
        // gridRef.current.api?.redrawRows();
        // gridRef.current.api?.refreshCells();

        setColumnDefs(prev => {
            return prev.map(item => {
                if (item.field === 'UserName') {
                    return { ...item, cellStyle: { backgroundColor: dark ? blue[900] : blue[50] } }
                } else {
                    return item
                }
            })
        })
        // gridRef.current?.api?.setGridOption('columnDefs', columnDefs);

    }, [dark]);
    useEffect(() => {

        setitems(initialItems);
        setsubItems(initialsubItems);

        // setColumnDefs([
        //     { field: 'barcode', headerName: intl.formatMessage({ id: "條碼號" }), width: 180, cellRenderer: 'agGroupCellRenderer' },
        //     { field: 'customerName', headerName: intl.formatMessage({ id: "專案名稱" }), width: 240 },
        //     { field: 'UserName', headerName: "姓名", width: 100, cellStyle: { backgroundColor: dark ? blue[900] : blue[50] } },
        //     { field: 'PersonalId', headerName: "身分證號", width: 130 },
        //     { field: 'sogi', headerName: "手機", width: 130 },
        //     { field: 'sex', headerName: "性別", width: 80 },
        //     { field: 'Birthday', headerName: "生日", width: 120 },
        //     { field: 'checkdate', headerName: "報到日", width: 120 },
        //     { field: 'status', headerName: "狀態", width: 80, cellRenderer: SwitchStatus },
        //     { field: 'UpdateCount', headerName: "夾圖", width: 80 },
        //     {
        //         field: 'email', headerName: "email", width: 290, editable: true,
        //         // cellEditorParams: {
        //         //     // 添加 email 驗證相關的參數
        //         //     required: true, // 必填
        //         // },
        //         // valueSetter: (params) => {
        //         //     // 自定義驗證邏輯，這裡確保值不為空
        //         //     if (params.newValue === "" || !PF.isValidEmail(params.newValue)) {
        //         //         enqueueSnackbar("無效的email請重新輸入", { variant: "error", style: { whiteSpace: 'pre-line' } });

        //         //         return false; // 驗證失敗
        //         //     }
        //         //     return true; // 驗證通過
        //         // },
        //         // cellEditorFramework: CustomInputEditor, // 使用自定義 email 驗證編輯器
        //     },
        //     { field: 'SendCount', headerName: "寄", width: 80, cellRenderer: SendNotify },


        // ])
        setColumnDefs(initialColumnDefs);
    }, [i18n.locale]);
    const initialColumnDefs = [
        { field: 'barcode', headerName: intl.formatMessage({ id: "條碼號" }), width: 180, cellRenderer: 'agGroupCellRenderer' },
        { field: 'customerName', headerName: intl.formatMessage({ id: "專案名稱" }), width: 240 },
        { field: 'UserName', headerName: intl.formatMessage({ id: "Name" }), width: 100, cellStyle: { backgroundColor: dark ? blue[900] : blue[50] } },
        { field: 'PersonalId', headerName: intl.formatMessage({ id: "ID." }), width: 130 },
        { field: 'UpdateCount', headerName: intl.formatMessage({ id: "夾圖" }), width: 80 },
        {
        field: 'status',
        headerName: intl.formatMessage({ id: "狀態" }),
        width: 80,
        cellRenderer: SwitchStatus,
        cellRendererParams: (params) => ({
            refreshCell: () => params.api.refreshCells({ rowNodes: [params.node], columns: ['status'] }),
            data: params.data,
            value: params.value,
            enqueueSnackbar: enqueueSnackbar,
        }),
    },
        { field: 'SendCount', headerName: intl.formatMessage({ id: "寄" }), width: 80, cellRenderer: SendNotify },
        {
            field: 'email', headerName: "email", width: 290, editable: true,
            // cellEditorParams: {
            //     // 添加 email 驗證相關的參數
            //     required: true, // 必填
            // },
            // valueSetter: (params) => {
            //     // 自定義驗證邏輯，這裡確保值不為空
            //     if (params.newValue === "" || !PF.isValidEmail(params.newValue)) {
            //         enqueueSnackbar("無效的email請重新輸入", { variant: "error", style: { whiteSpace: 'pre-line' } });

            //         return false; // 驗證失敗
            //     }
            //     return true; // 驗證通過
            // },
            // cellEditorFramework: CustomInputEditor, // 使用自定義 email 驗證編輯器
        },
        { field: 'sogi', headerName: intl.formatMessage({ id: "手機" }), width: 130 },
        { field: 'sex', headerName: intl.formatMessage({ id: "Gender" }), width: 80 },
        { field: 'Birthday', headerName: intl.formatMessage({ id: "Birth" }), width: 120 },
        { field: 'checkdate', headerName: intl.formatMessage({ id: "報到日" }), width: 120 },
        
       
       


    ]

    const [columnDefs, setColumnDefs] = React.useState(initialColumnDefs);
    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true,
    };
    const gridOptions = {
        getDetailRowData: function (params) {
            // 检查是否有子明细数据
            if (params.data.childData && params.data.childData.length > 0) {
                return params.data.childData; // 有子明细数据时返回数据
            } else {
                return null; // 没有子明细数据时返回 null
            }
        },
        isDetailOpen: function (params) {
            // 返回 true 或 false 来确定行是否处于展开状态
            return params.data.isExpanded; // 假设父行数据中有一个 isExpanded 字段表示展开状态
        },
    }

    const isRowMaster = useMemo(() => {
        return (dataItem) => {
            return dataItem ? dataItem.Children.length > 0 : false;
        };
    }, []);
    const detailCellRendererParams = useMemo(() => {
        return {
            detailGridOptions: {
                columnDefs: [
                    { field: 'barcode', headerName: "條碼號", width: 180 },
                    { field: 'FileName', headerName: "檔案名稱", minWidth: 150, width: 300 },
                ],
                defaultColDef: {
                    flex: 1,
                },

                rowSelection: 'single',
                onRowDoubleClicked: event => {
                    const { data } = event;
                    // console.log(data)
                    let s = _.replace(data.FullPathName, "\\\\192.168.25.20\\", "");
                    let t = s.replaceAll('\\', '/')
                    // console.log(t)
                    let str = "http://medirep.mornjoy.com.tw/Content/Upload/" + t
                    // console.log(str)
                    saveAs(str, data.FileName)

                }

            },
            getDetailRowData: (params) => {

                params.successCallback(params.data.Children);
            },
        };
    }, []);
    const onCellEditingStopped = (params) => {
        // var column = event.column; // 編輯的列
        // var rowNode = event.node; // 編輯的行節點
        // var editedValue = event.value; // 編輯後的值
        // console.log(event)
        // 在這裡可以執行更新數據的操作，例如保存到後端或更新本地數據
        // updateData(column, rowNode, editedValue);


        const editedData = params.data;
        var columnName = params.colDef.field;
        const { PersonalId, email } = editedData;
        // console.log(params)
        // console.log(editedData)

        if (PF.isValidEmail(email)) {
            PF.instance({
                method: "post",
                url: PF.url2 + "/Minmax/SetEmail",
                data: Qs.stringify({
                    Action: "1",
                    parameter: {
                        qc_id: PersonalId,
                        Email: email
                    }
                }),
                headers: { token: sessionStorage.token }
            })
                .then(function (response) {

                    // console.log(response.data)
                    const { TotalRecord, rows } = response.data
                    if (rows[0].status <= 0) {
                        // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                        enqueueSnackbar("查無資料", { variant: "error", style: { whiteSpace: 'pre-line' } });
                    } else {
                        // enqueueSnackbar("Success", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        // console.log(rows)

                    }
                    handleQuery();

                })


        } else {
            enqueueSnackbar("無效的email請重新輸入", { variant: "error", style: { whiteSpace: 'pre-line' } });
            // 如果輸入無效，還原為先前的值
            params.data[columnName] = params.oldValue;
            // 更新單元格以顯示還原後的值
            params.api.refreshCells({ columns: [columnName] });
        }

    };


    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        reportLoadSeqRef.current += 1;
        setOpen(false);
        resetReportState();

    };
    const [PersonItem, setPersonItem] = React.useState([])

    const handleQuery = (personalId) => {
        if (QueryString !== "") {
            setBackdropOpen(true)

            PF.instance({
                method: "post",
                url: PF.url2 + "/Minmax/GetIDList_Admini",
                data: Qs.stringify({
                    Action: "1",
                    parameter: {
                        PersonalId: QueryString
                    }
                }),
                headers: { Authorization: 'Bearer ' + localStorage.getItem("token") || token }
            })
                .then(function (response) {
                    setBackdropOpen(false)

                    // console.log(response.data)
                    const { TotalRecord, rows, rows3 } = response.data
                    if (TotalRecord <= 0) {
                        // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                        enqueueSnackbar("查無資料", { variant: "error", style: { whiteSpace: 'pre-line' } });
                    } else {
                        enqueueSnackbar("Success", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        // console.log(rows)
                        setPersonItem(rows3);
                    }
                })
        }
    }
    const handleQueryPersonID = (personalId) => {
        if (QueryString !== "") {
            setBackdropOpen(true)

            PF.instance({
                method: "post",
                url: PF.url2 + "/Minmax/GetIDList_Admini",
                data: Qs.stringify({
                    Action: "1",
                    parameter: {
                        PersonalId: personalId
                    }
                }),
                headers: { Authorization: 'Bearer ' + localStorage.getItem("token") || token }
            })
                .then(function (response) {
                    setBackdropOpen(false)

                    // console.log(response.data)
                    const { TotalRecord, rows, rows3 } = response.data
                    if (TotalRecord <= 0) {
                        // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                        enqueueSnackbar("查無資料", { variant: "error", style: { whiteSpace: 'pre-line' } });
                    } else {
                        enqueueSnackbar("Success", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        // console.log(rows)
                        gridRef.current.api.applyTransaction({ update: rows3 })

                    }
                })
        }
    }


    const getFullData = (BarCodeStr) => {
        // setBackdropOpen(true)
        const reportLoadSeq = reportLoadSeqRef.current + 1;
        reportLoadSeqRef.current = reportLoadSeq;
        resetReportState();

        PF.instance({
            method: "post",
            url: PF.url2 + "/Minmax/GetFullData_Admini",
            data: Qs.stringify({ Action: "none", parameter: { BarCodeStr } }),
            headers: { Authorization: 'Bearer ' + localStorage.getItem("token") || token }
        })
            .then(function (response) {
                // alert("完成")
                // setBackdropOpen(false)

                if (reportLoadSeq !== reportLoadSeqRef.current) {
                    return;
                }

                const { TotalRecord, Profile, LabData, GaugeData } = response.data;
                if (TotalRecord > 0) {
                    const people = Profile[0]
                    // console.log(rows);
                    setProfile({
                        age: people.age,
                        PersonalId: people.PersonalId,
                        UserName: people.UserName,
                        sogi: people.sogi,
                        checkdate: people.checkdate,
                        chart: people.chart,
                        barcode: people.barcode,
                        sex: people.sex || ' 男',
                        birthday: people.birthday || '1900/01/01'
                    })
                    //解析圖片為JSON物件
                    let PicJson = JSON.parse(Profile[0]["pic"]);

                    Object.keys(PicJson || {}).map(pic => {
                        if (PicJson[pic] !== null && PicJson[pic] !== "") {
                            // if (['pic_7010', 'pic_7012', 'pic_7013', 'pic_7014', 'pic_7015', 'pic_7016', 'pic_7020', 'pic_7023','pic_7033', 'pic_7052', 'pic_7054', 'pic_7091'].includes(pic))
                            setPicObj(prev => ({
                                ...prev,
                                [pic]: PicJson[pic]?.split(',') || []
                            }))
                        }


                    });
                    // console.log(PicJson);

                    //Lab
                    let ContentJson = JSON.parse(LabData[0]["content"]) || [];
                    // console.log(PF.multiFilter(ContentJson, { Err: ['true'] }))
                    const labErrItems = ContentJson.filter(x => x.Err === 'true');
                    setArray02(labErrItems)
                    // setArray02(prev => prev.concat(PF.multiFilter(ContentJson, { Err: ['true'] })))
                    setArray02_2(labErrItems)

                    // console.log(ContentJson);



                    let ContentJson2 = JSON.parse(GaugeData[0]["content"]) || [];
                    // console.log(ContentJson);

                    let ary03 = PF.multiFilter(ContentJson2, { CheckCategory: ['一般體格', '醫生問診'] });
                    console.log(ContentJson);
                    console.log(ContentJson2);
                    if (ary03.length > 0) {
                        setitems(prev => [...prev, { id: '03', title: ' - 理學檢查', data: ary03, i18n: intl.formatMessage({ id: "理學檢查" }) }])

                        // { id: '03', title: ' - 理學檢查', data: Array03 }
                        setArray03(ary03)

                    }
                    const CategoryArray04 = [
                        { id2: "0401", title2: "尿液常規檢查" },
                        { id2: "0402", title2: "尿沉渣" },
                        { id2: "0403", title2: "血液檢查" },
                        { id2: "0404", title2: "生化檢查" },
                        { id2: "0405", title2: "腫瘤標記" },
                        { id2: "0406", title2: "甲狀腺檢查" },
                        { id2: "0407", title2: "血清免疫檢查" },
                        { id2: "0408", title2: "賀爾蒙檢查" },
                        { id2: "0409", title2: "基因檢查" },
                        { id2: "0410", title2: "功能醫學" },
                        { id2: "0411", title2: "肝炎檢查" },
                        { id2: "0412", title2: "糞便檢查" },
                        { id2: "0413", title2: "重金屬檢查" },
                        { id2: "0414", title2: "微生物檢查" },
                    ];
                    if (ContentJson.length > 0) {
                        CategoryArray04.map(item => {
                            let y = ContentJson.filter(x => x.CheckCategory === item.title2)
                            // console.log(item)
                            if (y.length > 0) {
                                setsubItems(prev => ({
                                    ...prev,
                                    ['04']: [...prev['04'], { id2: item.id2, title2: item.title2, i18n2: intl.formatMessage({ id: item.title2 }) }]
                                }))
                            }
                        })
                        // console.log(CategoryArray04.map(object => object.title2))
                        let ary04 = PF.multiFilter(ContentJson, { CheckCategory: CategoryArray04.map(object => object.title2) })
                        setArray04(ary04)

                        // console.log(ary04)
                        if (ary04.length > 0) {
                            setitems(prev => [...prev, { id: '04', title: ' - 檢驗', data: ContentJson, i18n: intl.formatMessage({ id: "檢驗" }) }])
                        }
                    }

                    //Gauge


                    // setArray02_1(PF.multiFilter(ContentJson2, { Err: ['true'] }))
                    const gaugeErrItems = ContentJson2.filter(x => x.Err === 'true');
                    setArray02_1(gaugeErrItems)
                    setArray02([...gaugeErrItems, ...labErrItems])
                    // setArray02(prev => [...Array02, ...PF.multiFilter(ContentJson, { Err: ['true'] })])
                    // arr02 = [...arr02, ...PF.multiFilter(ContentJson, { Err: ['true'] })]

                    // let Array03 = PF.multiFilter(ContentJson, { CheckCategory: ['醫生問診'] });
                    // console.log(ContentJson);
                    // console.log(PF.multiFilter(ContentJson, { Err: ['true'] }))

                    let ItemArray = PF.multiFilter(ContentJson2, { CheckCategory: PicCategoryArray });
                    let ItemArray2 = PF.multiFilter(ContentJson, { CheckCategory: PicCategoryArray });
                    if (ItemArray2.length > 0) {
                        ItemArray = [...ItemArray, ...ItemArray2]
                    }
                    // console.log(ContentJson2);
                    // console.log(ItemArray);
                    // console.log(ItemArray2);
                    let object = _.keyBy(ItemArray, 'CheckCategory');
                    // console.log(object);
                    // console.log(ItemArray);
                    // console.log(object);
                    // console.log([...ContentJson2, ...ContentJson]);

                    let y = {}
                    Object.keys(object).map(CheckCategory => {
                        // y[CheckCategory] = PF.multiFilter([...ContentJson2, ...ContentJson], { CheckCategory: CheckCategory })
                        y[CheckCategory] = [...ContentJson2, ...ContentJson].filter(x => x.CheckCategory === CheckCategory)
                    })

                    // console.log(y);
                    setGaugeItem(y)
                    CategoryArray05.map((item, index) => {
                        if (y[item.title2]?.length > 0) {
                            setsubItems(prev => ({
                                ...prev,
                                ['05']: [...prev['05'], { id2: item.id2, title2: item.title2, i18n2: intl.formatMessage({ id: item.title2 }) }]
                            }))
                        }
                    })

                    if (Object.keys(y).length > 0) {
                        setitems(prev => [...prev, { id: '05', title: ' - 影像檢查', data: y, i18n: intl.formatMessage({ id: "影像檢查" }) }])

                    }

                    let array6 = PF.multiFilter(ContentJson2, { Category: ['其他檢查'] })
                    //希望的順序＆子頁碼
                    const CategoryArray06 = [
                        { id2: "0601", title2: "肺功能檢查", i18n2: intl.formatMessage({ id: "肺功能檢查" }) },
                        { id2: "0602", title2: "抹片檢查", i18n2: intl.formatMessage({ id: "抹片檢查" }) },
                        // { id2: "0603", title2: "功能醫學" },
                        { id2: "0604", title2: "分泌物檢查", i18n2: intl.formatMessage({ id: "分泌物檢查" }) },

                    ];
                    setArray06(array6)
                    if (array6.length > 0) {
                        setitems(prev => [...prev, { id: '06', title: ' - 其他檢查', data: array6, i18n: intl.formatMessage({ id: "其他檢查" }) }])
                        CategoryArray06.map(item => {
                            let y = array6.filter(x => x.CheckCategory === item.title2)
                            // console.log(item)
                            if (y.length > 0) {
                                setsubItems(prev => ({
                                    ...prev,
                                    ['06']: [...prev['06'], { id2: item.id2, title2: item.title2, i18n2: intl.formatMessage({ id: item.title2 }) }]
                                }))
                            }
                        })
                    }
                }
                else {
                }
            })
    }
    const handleMatch = e => {

        let selectedRows = gridRef.current.api.getSelectedRows();
        // console.log(selectedRows[0])
        // console.log(selectedRows[0])
        if (_.isNil(selectedRows[0])) {

            enqueueSnackbar(intl.formatMessage({ id: "PleaseSelectOne" }), { variant: "error", style: { whiteSpace: 'pre-line' } });
            return
        } else {
            setBackdropOpen(true);
            const { PersonalId, UserName, checkdate, id, barcode } = selectedRows[0];

            // console.log(moment(checkdate).format("M"));
            // console.log(new Date(checkdate).getMonth());

            PF.instance({
                method: "post",
                url: PF.url2 + "/Minmax/MatchQueryFile",
                data: Qs.stringify({
                    Action: "1",
                    parameter: {
                        qc_id: id,
                        BarCodeStr: barcode,
                        PersonalId: PersonalId,
                        UserName: UserName,
                        yyyym: new Date(checkdate).getFullYear() - 1911 + "." + (new Date(checkdate).getMonth() + 1),
                        mmdd: moment(new Date(checkdate)).format("MMDD")
                    }
                }),
                // headers: { token: sessionStorage.token }
            })
                .then(function (response) {

                    // console.log(response.data)
                    const { TotalRecord, files, imgs } = response.data
                    if (TotalRecord <= 0) {
                        // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                        enqueueSnackbar("查無PDF資料", { variant: "error", style: { whiteSpace: 'pre-line' } });
                        enqueueSnackbar("查得JPG資料: " + imgs.length + "筆", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        UpdateImages(imgs, id);
                        setBackdropOpen(false);

                    } else {
                        setBackdropOpen(false);

                        //更新PDF
                        enqueueSnackbar("查得PDF資料: " + TotalRecord + "筆", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        UpdateAppedix(files, id);

                        //更新JPG
                        enqueueSnackbar("查得JPG資料: " + imgs.length + "筆", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        UpdateImages(imgs, id);


                        // console.log(files);
                        // setPersonItem(rows3);
                    }
                })

        }

    }
    const UpdateAppedix = (files, qc_id) => {

        PF.instance({
            method: "post",
            url: PF.url2 + "/Minmax/UpdateAppendix",
            data: Qs.stringify({
                Action: "UPDATE",
                MyList: files,
                qc_id: qc_id
            }),
        })
            .then(function (response) {

                // console.log(response.data)
                const { TotalRecord, rows, error } = response.data
                if (error !== "") {
                    // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                    enqueueSnackbar("查無資料", { variant: "error", style: { whiteSpace: 'pre-line' } });
                } else {
                    let ResultStr = "更新PDF資料: " + TotalRecord + "筆";
                    enqueueSnackbar(ResultStr, { variant: "success", style: { whiteSpace: 'pre-line' } });
                    // console.log(rows)
                    // setPersonItem(rows3);
                }
            })

    }
    const getRowId = useMemo(() => {
        return (params) => {
            return params.data.id;
        };
    }, []);
    const specialFormat = string => {
        return encodeURI(string.replaceAll("\\", "/").replace("//192.168.25.20", "/Content/Upload"))
    }
    const UpdateImages = (person, id) => {
        // console.log(person);
        // console.log(id);
        let one = { qc_id: id }
        let bigperson = {}
        let bigpersonCount = {}

        if (!_.isEmpty(person)) {

            let pic_7010 = person.filter(function (person) { return person.FullPathName.includes("\\腹部超音波Abdominal echo\\") || person.FullPathName.includes("\\腹部超音波\\"); });
            if (!_.isEmpty(pic_7010)) {
                // console.log(pic_7010)
                bigperson.pic_7010 = pic_7010;
                bigpersonCount.pic_7010_alt = "§".repeat(pic_7010.length - 1);
            }

            let pic_7011 = person.filter(function (person) { return person.FullPathName.includes("\\攝護腺超音波Prostate echo\\") || person.FullPathName.includes("\\攝護腺超音波\\"); });
            if (!_.isEmpty(pic_7011)) {
                bigperson.pic_7011 = pic_7011;
                bigpersonCount.pic_7011_alt = "§".repeat(pic_7011.length - 1);
            }

            let pic_7012 = person.filter(function (person) { return person.FullPathName.includes("\\乳房超音波Breast Ultrasound\\") || person.FullPathName.includes("\\乳房超音波\\"); });
            if (!_.isEmpty(pic_7012)) {
                bigperson.pic_7012 = pic_7012;
                bigpersonCount.pic_7012_alt = "§".repeat(pic_7012.length - 1);
            }

            let pic_7013 = person.filter(function (person) { return person.FullPathName.includes("\\骨盆腔婦科超音波Gynecology Ultrasound\\") || person.FullPathName.includes("\\骨盆腔婦科超音波\\"); });
            if (!_.isEmpty(pic_7013)) {
                bigperson.pic_7013 = pic_7013;
                bigpersonCount.pic_7013_alt = "§".repeat(pic_7013.length - 1);
            }



            let pic_7015 = person.filter(function (person) { return person.FullPathName.includes("\\頸動脈超音波Carotid Duplex Ultrasound\\") || person.FullPathName.includes("\\頸動脈超音波\\"); });
            if (!_.isEmpty(pic_7015)) {
                bigperson.pic_7015 = pic_7015;
                bigpersonCount.pic_7015_alt = "§".repeat(pic_7015.length - 1);
            }

            let pic_7014 = person.filter(function (person) { return person.FullPathName.includes("\\甲狀腺超音波Thyroid echo\\") || person.FullPathName.includes("\\甲狀腺超音波\\"); });
            if (!_.isEmpty(pic_7014)) {
                bigperson.pic_7014 = pic_7014;
                bigpersonCount.pic_7014_alt = "§".repeat(pic_7014.length - 1);
            }

            let pic_7016 = person.filter(function (person) { return person.FullPathName.includes("\\心臟超音波Cardiac echo\\") || person.FullPathName.includes("\\心臟超音波\\"); });
            if (!_.isEmpty(pic_7016)) {
                bigperson.pic_7016 = pic_7016;
                bigpersonCount.pic_7016_alt = "§".repeat(pic_7016.length - 1);
            }

            let pic_7049 = person.filter(function (person) { return person.FullPathName.includes("\\胸部數位雙能量減影\\"); });
            if (!_.isEmpty(pic_7049)) {
                bigperson.pic_7049 = pic_7049;
                bigpersonCount.pic_7049_alt = "§".repeat(pic_7049.length - 1);
            }

            let pic_7033 = person.filter(function (person) { return person.FullPathName.includes("\\胸部CXR\\"); });
            if (!_.isEmpty(pic_7033)) {
                bigperson.pic_7033 = pic_7033;
                bigpersonCount.pic_7033_alt = "§".repeat(pic_7033.length - 1);
            }
            let pic_7093 = person.filter(function (person) { return person.FullPathName.includes("\\胸部CXR-側面\\"); });
            if (!_.isEmpty(pic_7093)) {
                bigperson.pic_7093 = pic_7093;
                bigpersonCount.pic_7093_alt = "§".repeat(pic_7093.length - 1);
            }

            let pic_7034 = person.filter(function (person) { return person.FullPathName.includes("\\腹部KUB\\"); });
            if (!_.isEmpty(pic_7034)) {
                bigperson.pic_7034 = pic_7034;
                bigpersonCount.pic_7034_alt = "§".repeat(pic_7034.length - 1);
            }
            let pic_7097 = person.filter(function (person) { return person.FullPathName.includes("\\肩胛骨X光-正面\\"); });
            if (!_.isEmpty(pic_7097)) {
                bigperson.pic_7097 = pic_7097;
                bigpersonCount.pic_7097_alt = "§".repeat(pic_7097.length - 1);
            }
            let pic_7098 = person.filter(function (person) { return person.FullPathName.includes("\\肩胛骨X光-側面\\"); });
            if (!_.isEmpty(pic_7098)) {
                bigperson.pic_7098 = pic_7098;
                bigpersonCount.pic_7098_alt = "§".repeat(pic_7098.length - 1);
            }

            let pic_7035 = person.filter(function (person) { return person.FullPathName.includes("\\頸椎X光-正面\\"); });
            if (!_.isEmpty(pic_7035)) {
                bigperson.pic_7035 = pic_7035;
                bigpersonCount.pic_7035_alt = "§".repeat(pic_7035.length - 1);
            }

            let pic_7036 = person.filter(function (person) { return person.FullPathName.includes("\\頸椎X光-側面\\"); });
            if (!_.isEmpty(pic_7036)) {
                bigperson.pic_7036 = pic_7036;
                bigpersonCount.pic_7036_alt = "§".repeat(pic_7036.length - 1);
            }

            let pic_7037 = person.filter(function (person) { return person.FullPathName.includes("\\胸椎X光-側面\\"); });
            if (!_.isEmpty(pic_7037)) {
                bigperson.pic_7037 = pic_7037;
                bigpersonCount.pic_7037_alt = "§".repeat(pic_7037.length - 1);
            }

            let pic_7038 = person.filter(function (person) { return person.FullPathName.includes("\\胸椎X光-正面\\"); });
            if (!_.isEmpty(pic_7038)) {
                bigperson.pic_7038 = pic_7038;
                bigpersonCount.pic_7038_alt = "§".repeat(pic_7038.length - 1);
            }

            let pic_7039 = person.filter(function (person) { return person.FullPathName.includes("\\腰椎X光-正面(L-spine AP)\\"); });
            if (!_.isEmpty(pic_7039)) {
                bigperson.pic_7039 = pic_7039;
                bigpersonCount.pic_7039_alt = "§".repeat(pic_7039.length - 1);
            }

            let pic_7040 = person.filter(function (person) { return person.FullPathName.includes("\\腰椎X光-側面(L-spine Lat)\\"); });
            if (!_.isEmpty(pic_7040)) {
                bigperson.pic_7040 = pic_7040;
                bigpersonCount.pic_7040_alt = "§".repeat(pic_7040.length - 1);
            }

            let pic_7061 = person.filter(function (person) { return person.FullPathName.includes("\\左手X光\\"); });
            if (!_.isEmpty(pic_7061)) {
                bigperson.pic_7061 = pic_7061;
                bigpersonCount.pic_7061_alt = "§".repeat(pic_7061.length - 1);
            }
            let pic_7050 = person.filter(function (person) { return person.FullPathName.includes("\\頭部數位斷層合成攝影\\"); });
            if (!_.isEmpty(pic_7050)) {
                bigperson.pic_7050 = pic_7050;
                bigpersonCount.pic_7050_alt = "§".repeat(pic_7050.length - 1);

            } let pic_7051 = person.filter(function (person) { return person.FullPathName.includes("\\頸部數位斷層合成攝影\\"); });
            if (!_.isEmpty(pic_7051)) {
                bigperson.pic_7051 = pic_7051;
                bigpersonCount.pic_7051_alt = "§".repeat(pic_7051.length - 1);
            }

            let pic_7052 = person.filter(function (person) { return person.FullPathName.includes("\\胸部數位斷層合成攝影\\"); });
            if (!_.isEmpty(pic_7052)) {
                bigperson.pic_7052 = pic_7052;
                bigpersonCount.pic_7052_alt = "§".repeat(pic_7052.length - 1);
            }
            let pic_7053 = person.filter(function (person) { return person.FullPathName.includes("\\腹部數位斷層合成攝影\\"); });
            if (!_.isEmpty(pic_7053)) {
                bigperson.pic_7053 = pic_7053;
                bigpersonCount.pic_7053_alt = "§".repeat(pic_7053.length - 1);
            }

            let pic_7062 = person.filter(function (person) { return person.FullPathName.includes("\\右手X光\\"); });
            if (!_.isEmpty(pic_7062)) {
                bigperson.pic_7062 = pic_7062;
                bigpersonCount.pic_7062_alt = "§".repeat(pic_7062.length - 1);
            }

            let pic_8009 = person.filter(function (person) { return person.FullPathName.includes("\\小腿X光(正面)\\"); });
            if (!_.isEmpty(pic_8009)) {
                bigperson.pic_8009 = pic_8009;
                bigpersonCount.pic_8009_alt = "§".repeat(pic_8009.length - 1);
            }

            let pic_8010 = person.filter(function (person) { return person.FullPathName.includes("\\小腿X光(左腳)\\"); });
            if (!_.isEmpty(pic_8010)) {
                bigperson.pic_8010 = pic_8010;
                bigpersonCount.pic_8010_alt = "§".repeat(pic_8010.length - 1);
            }

            let pic_8011 = person.filter(function (person) { return person.FullPathName.includes("\\小腿X光(右腳)\\"); });
            if (!_.isEmpty(pic_8011)) {
                bigperson.pic_8011 = pic_8011;
                bigpersonCount.pic_8011_alt = "§".repeat(pic_8011.length - 1);
            }

            let pic_8012 = person.filter(function (person) { return person.FullPathName.includes("\\膝蓋X光-正面\\"); });
            if (!_.isEmpty(pic_8012)) {
                bigperson.pic_8012 = pic_8012;
                bigpersonCount.pic_8012_alt = "§".repeat(pic_8012.length - 1);
            }

            let pic_8013 = person.filter(function (person) { return person.FullPathName.includes("\\膝蓋X光-側面(左)\\"); });
            if (!_.isEmpty(pic_8013)) {
                bigperson.pic_8013 = pic_8013;
                bigpersonCount.pic_8013_alt = "§".repeat(pic_8013.length - 1);
            }

            let pic_8014 = person.filter(function (person) { return person.FullPathName.includes("\\膝蓋X光-側面(右)\\"); });
            if (!_.isEmpty(pic_8014)) {
                bigperson.pic_8014 = pic_8014;
                bigpersonCount.pic_8014_alt = "§".repeat(pic_8014.length - 1);
            }

            let pic_7054 = person.filter(function (person) { return person.FullPathName.includes("\\全脊椎數位X光攝影\\"); });
            if (!_.isEmpty(pic_7054)) {
                bigperson.pic_7054 = pic_7054;
                bigpersonCount.pic_7054_alt = "§".repeat(pic_7054.length - 1);
            }

            let pic_7055 = person.filter(function (person) { return person.FullPathName.includes("\\下肢數位X光攝影\\"); });
            if (!_.isEmpty(pic_7055)) {
                bigperson.pic_7055 = pic_7055;
                bigpersonCount.pic_7055_alt = "§".repeat(pic_7055.length - 1);
            }

            let pic_7045 = person.filter(function (person) { return person.FullPathName.includes("\\上消化道內視鏡\\"); });
            if (!_.isEmpty(pic_7045)) {
                bigperson.pic_7045 = pic_7045;
                bigpersonCount.pic_7045_alt = "§".repeat(pic_7045.length - 1);
            }

            let pic_7046 = person.filter(function (person) { return person.FullPathName.includes("\\下消化道內視鏡\\"); });
            if (!_.isEmpty(pic_7046)) {
                bigperson.pic_7046 = pic_7046;
                bigpersonCount.pic_7046_alt = "§".repeat(pic_7046.length - 1);
            }

            let pic_7029 = person.filter(function (person) { return person.FullPathName.includes("\\無痛大腸鏡檢查\\"); });
            if (!_.isEmpty(pic_7029)) {
                bigperson.pic_7029 = pic_7029;
                bigpersonCount.pic_7029_alt = "§".repeat(pic_7029.length - 1);
            }

            let pic_7030 = person.filter(function (person) { return person.FullPathName.includes("\\無痛胃鏡檢查\\"); });
            if (!_.isEmpty(pic_7030)) {
                bigperson.pic_7030 = pic_7030;
                bigpersonCount.pic_7030_alt = "§".repeat(pic_7030.length - 1);
            }

            let pic_7031 = person.filter(function (person) { return person.FullPathName.includes("\\胃鏡檢查\\"); });
            if (!_.isEmpty(pic_7031)) {
                bigperson.pic_7031 = pic_7031;
                bigpersonCount.pic_7031_alt = "§".repeat(pic_7031.length - 1);
            }

            let pic_7070 = person.filter(function (person) { return person.FullPathName.includes("\\胃鏡病理報告\\"); });
            if (!_.isEmpty(pic_7070)) {
                bigperson.pic_7070 = pic_7070;
                bigpersonCount.pic_7070_alt = "§".repeat(pic_7070.length - 1);
            }

            let pic_7032 = person.filter(function (person) { return person.FullPathName.includes("\\大腸鏡檢查\\"); });
            if (!_.isEmpty(pic_7032)) {
                bigperson.pic_7032 = pic_7032;
                bigpersonCount.pic_7032_alt = "§".repeat(pic_7032.length - 1);
            }

            let pic_7063 = person.filter(function (person) { return person.FullPathName.includes("\\乙狀結腸\\"); });
            if (!_.isEmpty(pic_7063)) {
                bigperson.pic_7063 = pic_7063;
                bigpersonCount.pic_7063_alt = "§".repeat(pic_7063.length - 1);
            }

            // let pic_7076 = person.filter(function (person) { return person.FullPathName.includes("\\雙能量X光骨質吸收儀(DXA)-髖關節\\"); });
            // if (!_.isEmpty(pic_7076)) {
            //     bigperson.pic_7076 = pic_7076;
            //     bigpersonCount.pic_7076_alt = "§".repeat(pic_7076.length - 1);
            // }

            let pic_7021 = person.filter(function (person) { return person.FullPathName.includes("\\DXA 檢查\\") || person.FullPathName.includes("\\雙能量X光骨質吸收儀(DXA)\\");; });
            if (!_.isEmpty(pic_7021)) {
                bigperson.pic_7021 = pic_7021;
                bigpersonCount.pic_7021_alt = "§".repeat(pic_7021.length - 1);
            }

            let pic_7075 = person.filter(function (person) { return person.FullPathName.includes("\\DXA 左側股骨\\") || person.FullPathName.includes("\\DXA DualFemur\\") || person.FullPathName.includes("\\雙能量X光骨質吸收儀(DXA)-髖關節\\"); });
            if (!_.isEmpty(pic_7075)) {
                bigperson.pic_7075 = pic_7075;
                bigpersonCount.pic_7075_alt = "§".repeat(pic_7075.length - 1);
            }

            let pic_7091 = person.filter(function (person) { return person.FullPathName.includes("\\DXA 正面脊椎\\") || person.FullPathName.includes("\\雙能量X光骨質吸收儀(DXA)-腰椎\\"); });
            if (!_.isEmpty(pic_7091)) {
                bigperson.pic_7091 = pic_7091;
                bigpersonCount.pic_7091_alt = "§".repeat(pic_7091.length - 1);
            }
            let pic_7092 = person.filter(function (person) { return person.FullPathName.includes("\\全自動乳房掃描\\") });
            if (!_.isEmpty(pic_7092)) {
                bigperson.pic_7092 = pic_7092;
                bigpersonCount.pic_7092_alt = "§".repeat(pic_7092.length - 1);
            }

            let pic_7020 = person.filter(function (person) { return person.FullPathName.includes("\\DXA 全身\\"); });
            if (!_.isEmpty(pic_7020)) {
                bigperson.pic_7020 = pic_7020;
                bigpersonCount.pic_7020_alt = "§".repeat(pic_7020.length - 1);
            }
            //2023/06/12改新報的夾圖
            // let pic_7060 = person.filter(function (person) { return person.FullPathName.includes(one.UserName.replaceAll("?", "") + ".jpg"); });
            // if (!_.isEmpty(pic_7060)) {
            //     bigperson.pic_7060 = pic_7060;
            //     bigpersonCount.pic_7060_alt = "§".repeat(pic_7060.length - 1);
            // }

            let pic_7060 = person.filter(function (person) { return person.FullPathName.includes("\\InBody體脂肪機\\"); });
            if (!_.isEmpty(pic_7060)) {
                bigperson.pic_7060 = pic_7060;
                bigpersonCount.pic_7060_alt = "§".repeat(pic_7060.length - 1);
            }

            let pic_7008 = person.filter(function (person) { return person.FullPathName.includes("\\靜式心電圖EKG\\"); });
            if (!_.isEmpty(pic_7008)) {
                bigperson.pic_7008 = pic_7008;
                bigpersonCount.pic_7008_alt = "§".repeat(pic_7008.length - 1);
            }

            let pic_7007 = person.filter(function (person) { return person.FullPathName.includes("\\運動心電圖EKG\\"); });
            if (!_.isEmpty(pic_7007)) {
                bigperson.pic_7007 = pic_7007;
                bigpersonCount.pic_7007_alt = "§".repeat(pic_7007.length - 1);
            }

            let pic_7042 = person.filter(function (person) { return person.FullPathName.includes("page-1.jpg") || person.FullPathName.includes("page-2.jpg"); });
            if (!_.isEmpty(pic_7042)) {
                bigperson.pic_7042 = pic_7042;
                bigpersonCount.pic_7042_alt = "§".repeat(pic_7042.length - 1);
                //2023/11/16新增
                bigperson.pic_7162 = pic_7042;
                bigpersonCount.pic_7162_alt = "§".repeat(pic_7042.length - 1);

            }

            let pic_7041 = person.filter(function (person) { return person.FullPathName.includes("page-3.jpg") || person.FullPathName.includes("page-4.jpg"); });
            if (!_.isEmpty(pic_7041)) {
                bigperson.pic_7041 = pic_7041;
                bigpersonCount.pic_7041_alt = "§".repeat(pic_7041.length - 1);
            }

            let pic_7023 = person.filter(function (person) { return person.FullPathName.includes("\\眼底攝影\\"); });
            if (!_.isEmpty(pic_7023)) {
                bigperson.pic_7023 = pic_7023;
                bigpersonCount.pic_7023_alt = "§".repeat(pic_7023.length - 1);
            }


            // bigperson.cpic = "";
            // bigpersonCount.cpic_alt = "";

            // console.log(bigperson);
            // console.log(bigpersonCount);


            //格式轉換
            Object.keys(bigperson).map(item => {
                bigperson[item] = !_.isEmpty(bigperson[item]) ? bigperson[item].map(i => specialFormat(i.FullPathName)).join(",") : null;
            })
            //變更資料源
            // setRows(prevstate => (prevstate.map(item => {
            //     if (item.PersonalId === personalId) {
            //         return {
            //             ...item,
            //             pic: JSON.stringify(bigperson),
            //             pic_alt: JSON.stringify(bigpersonCount)
            //         }
            //     } else return item
            // })
            // ));
            // enqueueSnackbar("匹配成功", { variant: "Success", style: { whiteSpace: 'pre-line' } });
            one.pic = JSON.stringify(bigperson);
            one.pic_alt = JSON.stringify(bigpersonCount);

            // console.log(one)

            PF.instance({
                method: "post",
                url: PF.url2 + "/Minmax/UpdateJPG",
                data: Qs.stringify({
                    Action: "Update",
                    parameter: {
                        PersonalId: one,
                        qc_id: one.qc_id,
                        pic: one.pic,
                        pic_alt: one.pic_alt
                    }
                }),
                headers: { token: sessionStorage.token }
            })
                .then(function (response) {

                    // console.log(response.data)
                    const { TotalRecord, rows } = response.data
                    if (TotalRecord <= 0) {
                        // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                        enqueueSnackbar("JPG圖檔更新失敗", { variant: "error", style: { whiteSpace: 'pre-line' } });
                    } else {
                        enqueueSnackbar("JPG圖檔更新成功", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        handleQueryPersonID(one.qc_id)// console.log(rows)
                    }
                })


        }
    }
    const handleItem5005 = (e) => {
        PF.instance({
            method: "post",
            url: PF.url2 + "/CheckItem/SetItemNo5005",
            data: Qs.stringify({
                Action: "Update",
                parameter: {
                    DateStart: QueryDate
                }
            }
            ),
            headers: { token: sessionStorage.token }
        })
            .then(function (response) {
                const { TotalRecord, result, rows } = response.data;
                console.log(response.data);
                const [QueryResult] = result;
                if (QueryResult["ErrMsg"] === '1') {
                    enqueueSnackbar("更新" + TotalRecord + '筆資料', { variant: "success", style: { whiteSpace: 'pre-line' } });
                } else {
                    enqueueSnackbar("當日資料判讀有誤: " + QueryResult["ErrMsg"], { variant: "error", style: { whiteSpace: 'pre-line' } });
                }

            })

    }
    const handleDelete = (e) => {
        e.preventDefault();

        let selectedRows = gridRef.current.api.getSelectedRows();
        // console.log(selectedRows[0])
        // console.log(selectedRows[0])
        if (_.isNil(selectedRows[0])) {

            enqueueSnackbar(intl.formatMessage({ id: "PleaseSelectOne" }), { variant: "error", style: { whiteSpace: 'pre-line' } });
            return
        } else {
            const [data] = selectedRows
            // console.log(data);
            PF.instance({
                method: "post",
                url: PF.url2 + "/Minmax/SetStatus",
                data: Qs.stringify({
                    Action: "DELETE",
                    parameter: {
                        qc_id: data.id,
                        Status: "D"
                    }
                }),
                headers: { token: sessionStorage.token }
            })
                .then(function (response) {
                    const { TotalRecord, rows } = response.data
                    const [Err] = rows
                    if (Err.ErrMsg === "1") {
                        enqueueSnackbar("更新成功", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        gridRef.current.api.applyTransaction({ remove: selectedRows })


                    } else {
                        enqueueSnackbar("更新失敗", { variant: "error", style: { whiteSpace: 'pre-line' } });

                    }
                })




        }

    }
    const statusBar = useMemo(() => {
        return {
            statusPanels: [
                { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
                // { statusPanel: 'agTotalRowCountComponent' },
                // { statusPanel: 'agFilteredRowCountComponent' },
                // { statusPanel: 'agSelectedRowCountComponent', align: 'left' },
                { statusPanel: 'agAggregationComponent' },
            ],
        };
    }, []);


    return (

        <div style={{ paddingTop: 30 }}>
            <Grid container >
                <Grid item xs={8}>
                    <form onSubmit={handleQuery}>
                        <Paper
                            component="form"
                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 530 }}

                        >
                            <IconButton sx={{ p: '10px' }} aria-label="menu">
                                <MenuIcon />
                            </IconButton>
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder={intl.formatMessage({ id: 'PleaseEnterID' })}
                                value={QueryString}
                                onChange={handleChange}
                                onKeyPress={(event) => {
                                    if (event.key === 'Enter') {
                                        event.preventDefault(); //會Refresh
                                        handleQuery();
                                    }
                                }}
                            />
                            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                            <IconButton color="primary" sx={{ p: '8px' }} aria-label="directions" onClick={handleQuery}>
                                <SearchIcon />
                            </IconButton>
                            <Stack direction="row" spacing={2}>
                                <Button variant="outlined" name={"Match"} onClick={handleMatch}>Match</Button>
                                <Button variant="contained" onClick={handleDelete} color="error">{intl.formatMessage({ id: "DeleteReport" })}</Button>
                            </Stack>
                             {/* <SwitchAllStatusButton rowData={PersonItem} setRowData={setPersonItem} /> */}
                        </Paper>
                       


                    </form>

                </Grid>
                <Grid item xs={4} sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}>
                    <IconButton onClick={handlePreviosDate} variant="outlined" size='small'>
                        <KeyboardArrowLeftIcon />
                    </IconButton>
                    <DatePicker onChange={handleDateChange} locale={locale} defaultValue={dayjs(QueryDate)} format={'YYYY/MM/DD'} allowClear={false} value={dayjs(QueryDate)} />
                    <IconButton onClick={handleNextDate} variant="outlined" size='small'>
                        <KeyboardArrowRightIcon />
                    </IconButton>
                    <Typography color={dayjs(QueryDate).day() === 0 ? red[500] : null}>{'星期' + week[dayjs(QueryDate).day()]}</Typography>
                    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                    <Button variant='contained' color='success' onClick={handleItem5005}>5005判讀</Button>
                </Grid>

            </Grid>
            <div className={dark ? "ag-theme-balham-dark" : "ag-theme-balham"} style={{ height: '86vh', width: '95vw' }}>
                <AgGridReact
                    // rowHeight={30}
                    ref={gridRef}
                    rowData={PersonItem}
                    columnDefs={columnDefs}
                    getRowId={getRowId}
                    onCellEditingStopped={onCellEditingStopped}
                    rowSelection='single'
                    defaultColDef={defaultColDef}
                    // rowMultiSelectWithClick={true}
                    masterDetail={true}
                    detailCellRendererParams={detailCellRendererParams}
                    // onFirstDataRendered={onFirstDataRendered}
                    // onRowDoubleClicked={onRowDoubleClicked}
                    onCellDoubleClicked={onRowDoubleClicked}
                    isRowMaster={isRowMaster}
                    // enableCellTextSelection={true}
                    // ensureDomOrder={true}
                    // groupSelectsFiltered={true}
                    // suppressRowClickSelection={true}
                    // onCellValueChanged={onCellValueChanged}
                    enableRangeSelection={true}
                    gridOptions={gridOptions}
                    statusBar={statusBar}


                />
            </div>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
            >
                <DialogTitle style={{ backgroundColor: indigo[500], paddingBottom: 30 }}>

                    <IconButton style={{
                        position: 'absolute',
                        right: 5,
                        top: 5,

                    }}
                        onClick={handleClose}
                    >
                        <CloseIcon style={{ color: "white" }} />
                    </IconButton>
                </DialogTitle >
                <DialogContent dividers style={{ padding: 0 }}>
                    <Minmax Array02={Array02} items={items} Profile={Profile} Array03={Array03} Array04={Array04}
                        Array06={Array06} GaugeItem={GaugeItem} PicObj={PicObj} Array02_1={Array02_1} Array02_2={Array02_2} subItems={subItems} seturl={seturl} {...props} />
                </DialogContent>

            </Dialog>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={BackdropOpen}
            // onClick={handleClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>



    )
}


const PersistentDrawerLeft = (props) => {
    const dispatch = useDispatch();

    const { dark, i18n } = useSelector(state => ({
        dark: state.app.dark,
        i18n: state.app.i18n,
    }));
    const [playActive] = useSound(
        switchlight,
        { volume: 0.5 }
    );
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    const navigate = useNavigate();
    const intl = useIntl();
    const handleLogout = () => {
        navigate(`/AdminLogin`, { replace: true });
        dispatch(actions.UserInfo({}));
        dispatch(actions.TOKEN_SET(""));
        localStorage.removeItem("UserInfo");
        localStorage.removeItem("token");
        // return redirect("/MinmaxLogin");
        // return <Navigate to="/MinmaxLogin" replace={true} />
    }
    const [anchorEl, setAnchorEl] = React.useState(null);
    const TranslateOpen = Boolean(anchorEl);
    const handleTranslateClose = () => {
        setAnchorEl(null);
    };
    const handleI18nChange = (event, lang) => {
        moment.locale(lang);
        dispatch(actions.LANG_SET(lang));
        setAnchorEl(null);
        playActive();
    };
    const [tabs, setTabs] = useState([]); // 開啟的 tab 列表
    const [activeTab, setActiveTab] = useState(null); // 當前 active tab
    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar2 position="fixed" open={open} >
                <Toolbar style={{ minHeight: 50, height: 50 }}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        sx={{ mr: 2, ...(open && { display: 'none' }) }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap component="div">
                        {intl.formatMessage({ id: 'TitleName' })}
                    </Typography>
                </Toolbar>
            </AppBar2>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >
                <DrawerHeader style={{ minHeight: 50, height: 50 }}>
                    <Typography style={{ flex: 1, display: "flex", justifyContent: "center" }}>晨悅診所</Typography>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                <List>

                    <ListItem key={1} disablePadding>
                        <ListItemButton onClick={() => dispatch(actions.THEME_SET({ theme: !dark }))}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                // e.stopPropagation();
                                playActive()
                            }}
                        >
                            <ListItemIcon>
                                <DarkModeSwitch
                                    // style={{ marginBottom: '2rem', float: "right" }}
                                    checked={dark}
                                    size={20} />
                            </ListItemIcon>
                            <ListItemText primary={!dark ? "Light" : "Dark"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={2} disablePadding style={{ cursor: 'pointer' }}>
                        <ListItemButton onClick={e => { setAnchorEl(e.currentTarget); }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                // e.stopPropagation();
                                playActive()
                            }}
                        >
                            <ListItemIcon>
                                <GTranslate />
                            </ListItemIcon>
                            <ListItemText primary={i18n.locale === "zh-tw" ? "繁體中文" : "English"} />
                        </ListItemButton>
                    </ListItem>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={TranslateOpen}
                        onClose={handleTranslateClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                        value={i18n.locale}

                    >
                        <MenuItem style={{ color: i18n.locale === "zh-tw" ? "white" : "", backgroundColor: i18n.locale === "zh-tw" ? teal[700] : "" }} selected={i18n.locale === "zh-tw"} value="zh-tw" onClick={(e) => handleI18nChange(e, "zh-tw")}>繁體中文</MenuItem>
                        <MenuItem style={{ color: i18n.locale === "en" ? "white" : "", backgroundColor: i18n.locale === "en" ? teal[700] : "" }} selected={i18n.locale === "en"} value="en" onClick={(e) => handleI18nChange(e, "en")}>English</MenuItem>
                    </Menu>
                     <ListItem key={3} disablePadding>
                    <ListItemButton onClick={() => {
                        const tabKey = 'GenerateReport';
                        const existingTab = tabs.find(tab => tab.key === tabKey);

                        if (!existingTab) {
                            setTabs([...tabs, {
                                key: tabKey,
                                title: i18n.locale === "zh-tw" ? "產生報告書" : "Generate Report",
                                component: <GenerateReport /> // 報告頁元件
                            }]);
                        }

                        setActiveTab(tabKey);
                        playActive();
                    }}>
                        <ListItemIcon>
                            <GetAppIcon />
                        </ListItemIcon>
                        <ListItemText 
                            primary={i18n.locale === "zh-tw" ? "產生報告書" : "Generate Report"} 
                        />
                    </ListItemButton>
                </ListItem>
                 <ListItem key={4} disablePadding>
                    <ListItemButton onClick={() => {
                        const tabKey = 'AnnualReport';
                        const existingTab = tabs.find(tab => tab.key === tabKey);

                        if (!existingTab) {
                            setTabs([...tabs, {
                                key: tabKey,
                                title: i18n.locale === "zh-tw" ? "年度健檢數值" : "Annual Report",
                                component: <AnnualReport /> // 報告頁元件
                            }]);
                        }

                        setActiveTab(tabKey);
                        playActive();
                    }}>
                        <ListItemIcon>
                            <SlideshowIcon />
                        </ListItemIcon>
                        <ListItemText 
                            primary={i18n.locale === "zh-tw" ? "年度健檢數值" : "Annual Report"} 
                        />
                    </ListItemButton>
                </ListItem>
                 <ListItem key={5} disablePadding>
                    <ListItemButton onClick={() => {
                        const tabKey = 'QueryLostitem';
                        const existingTab = tabs.find(tab => tab.key === tabKey);

                        if (!existingTab) {
                            setTabs([...tabs, {
                                key: tabKey,
                                title: i18n.locale === "zh-tw" ? "報告缺漏查詢" : "Report Omission",
                                component: <QueryLostitem /> // 報告頁元件
                            }]);
                        }

                        setActiveTab(tabKey);
                        playActive();
                    }}>
                        <ListItemIcon>
                            <PageviewIcon />
                        </ListItemIcon>
                        <ListItemText 
                            primary={i18n.locale === "zh-tw" ? "報告缺漏查詢" : "Report Omission"} 
                        />
                    </ListItemButton>
                </ListItem>
                    <ListItem key={6} disablePadding>
                        <ListItemButton onClick={handleLogout}>
                            <ListItemIcon>
                                <ExitToAppIcon />
                            </ListItemIcon>
                            <ListItemText primary={intl.formatMessage({ id: "app.Logout" })} />
                        </ListItemButton>
                    </ListItem>

                </List>
            </Drawer>
        <Main open={open}>
            {/* Tabs 區塊 */}
            {tabs.length > 0 && (
                <>
                <Box sx={{ mt: 1 }}> {/* 這裡讓 Tabs 整體往下移一點 */}
                    <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => setActiveTab(newValue)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        borderBottom: 1,
                        borderColor: "divider",
                        // minHeight: 30, // Tabs 區塊高度縮小
                    }}
                    >
                    {tabs.map((tab) => (
                        <Tab
                        key={tab.key}
                        value={tab.key}
                        label={
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                            {tab.title}
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                e.stopPropagation();
                                setTabs(tabs.filter((t) => t.key !== tab.key));
                                if (activeTab === tab.key) {
                                    const remaining = tabs.filter(
                                    (t) => t.key !== tab.key
                                    );
                                    setActiveTab(
                                    remaining.length > 0 ? remaining[0].key : null
                                    );
                                }
                                }}
                            >
                                ✕
                            </IconButton>
                            </Box>
                        }
                        sx={{ minHeight: 36 }} // 每個 Tab 高度也縮小
                        />
                    ))}
                    </Tabs>
                </Box>

                {/* Tab 內容 */}
                <Box sx={{ mt: 2 }}>
                    {tabs.map((tab) => (
                    <div
                        key={tab.key}
                        style={{ display: tab.key === activeTab ? "block" : "none" }}
                    >
                        {tab.component}
                    </div>
                    ))}
                </Box>
                </>
            )}

            {/* 永遠保留 App，但當有 Tab 時隱藏 */}
            <div style={{ display: tabs.length > 0 ? "none" : "block" }}>
                <App {...props} />
            </div>
         </Main>
        </Box >
    );
}


export default PersistentDrawerLeft
